"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "isola-del-liri": {
    "818f8d41": [{
      "hkey": "32a71032",
      "slug": "isola-del-liri",
      "name": "Isola del Liri",
      "primary": true,
      "skipSearch": false
    }],
    "capitino": [{
      "hkey": "32a71032",
      "slug": "isola-del-liri",
      "name": "Isola del Liri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "164a6326": [{
      "hkey": "32a71032",
      "slug": "isola-del-liri",
      "name": "Isola del Liri",
      "primary": true,
      "skipSearch": false
    }],
    "carnello": [{
      "hkey": "32a71032",
      "slug": "isola-del-liri",
      "name": "Isola del Liri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2397c87e": [{
      "hkey": "32a71032",
      "slug": "isola-del-liri",
      "name": "Isola del Liri",
      "primary": true,
      "skipSearch": false
    }],
    "san-domenico": [{
      "hkey": "32a71032",
      "slug": "isola-del-liri",
      "name": "Isola del Liri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd88448c": [{
      "hkey": "32a71032",
      "slug": "isola-del-liri",
      "name": "Isola del Liri",
      "primary": true,
      "skipSearch": false
    }],
    "selva": [{
      "hkey": "32a71032",
      "slug": "isola-del-liri",
      "name": "Isola del Liri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;